import { create } from 'zustand';
import { Profile } from '../types/profile';
import { Team } from '../types/team';

interface ProfileState {
  activeProfile: Profile | null;
  activeTeam: Team | null;
  setActiveProfile: (profile: Profile | null) => void;
  setActiveTeam: (team: Team | null) => void;
}

export const useProfileStore = create<ProfileState>((set) => ({
  activeProfile: null,
  activeTeam: null,
  setActiveProfile: (activeProfile) => set({ activeProfile }),
  setActiveTeam: (activeTeam) => set({ activeTeam }),
}));
